import { render, staticRenderFns } from "./NoticeDetail.vue?vue&type=template&id=7ba3eacf&scoped=true&"
import script from "./NoticeDetail.vue?vue&type=script&lang=js&"
export * from "./NoticeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba3eacf",
  null
  
)

component.options.__file = "NoticeDetail.vue"
export default component.exports